import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "questionnaire-list" }
const _hoisted_2 = { class: "checkbox" }
const _hoisted_3 = ["id", "name", "value", "onUpdate:modelValue"]
const _hoisted_4 = ["for"]

import {computed, ref, watch} from "vue";
import {QuestionEntry, RawAnswer} from "@/lib/QuestionHandler";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleChoiceQuestion',
  props: {
    modelValue: {},
    question: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const value = ref<{ [id: number]: boolean}>({})

const emitAnswer = () => {
  const enabledKeys = Object.keys(value.value)
      .filter((key: any) => value.value[key])

  emit(
      "update:modelValue",
      enabledKeys
  )
}

watch(() => props.question, () => {
  value.value = props.question.answers.reduce((res: { [id: number]: boolean}, answer) => {
    res[answer.id] = !! props.question.selectedAnswers.filter(selectedAnswer => selectedAnswer.id === answer.id).length
    return res
  }, {})
}, { immediate: true, deep: true })

watch(() => value, emitAnswer, { immediate: true, deep: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answers, (answer) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row-level2",
        key: answer.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: `answer-${answer.id}`,
            name: `choice-${_ctx.question.id}`,
            value: answer.id,
            "onUpdate:modelValue": ($event: any) => ((value.value[answer.id]) = $event)
          }, null, 8, _hoisted_3), [
            [_vModelCheckbox, value.value[answer.id]]
          ])
        ]),
        _createElementVNode("label", {
          for: `answer-${answer.id}`
        }, _toDisplayString(answer.description), 9, _hoisted_4)
      ]))
    }), 128))
  ]))
}
}

})